import React from 'react';

const Title = ({ record }) => {
  return <span>Farm { record ? `"${record.name}"` : '' }</span>;
};

export default Title;
